module.exports = __webpack_public_path__ + "static/media/yellow_1.06841571.jpg";